import { render } from "./Flag.vue?vue&type=template&id=5ccd9fb2&ts=true"
import script from "./Flag.vue?vue&type=script&lang=ts"
export * from "./Flag.vue?vue&type=script&lang=ts"

import "./Flag.vue?vue&type=style&index=0&id=5ccd9fb2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__